<template>
  <div id="wrapper">
  <div class="content">

      <div class="hpanel">
        <div class="panel-body" id="html-2-pdfwrapper">
          <biblio-tree :nodes="nodes" :depth="0" :print="false" :parentCounter="0" :ref-depth="{}"/>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>

import BiblioTree from './BiblioTree'
import {sortByDepth} from '../../assets/scripts/biblio'

export default {
  components: {BiblioTree},
  props: [],
  name: 'BiblioPreview',
  data () {
    return {
      biblio: null,
      nodes: {}
    }
  },
  methods: {
    getResources: function () {
      let biblioId = this.$route.params.biblio_id

      this.axios.get('/biblio/' + biblioId)
        .then((response) => {
          this.biblio = response.data
          this.nodes = sortByDepth(this.biblio.content)
        })
        .catch(() => {
        })
    }
  },
  beforeMount () {
    this.getResources()
  }
}

</script>



// WEBPACK FOOTER //
// src/components/biblio/BiblioPreview.vue